import user from "apis/user";
import { HTTP_GET, HTTP_DELETE, WebApiRequest } from "tools/webservice";

export const getUserRoles = (internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: user.getRoles(internetUserId),
  successCallback,
  mountedRef
});

export const removeUserRole = (internetUserId, roleName, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: user.removeRole(internetUserId, roleName),
  successCallback,
  mountedRef
});

export const getAllRoles = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: user.allRoles(),
  successCallback,
  mountedRef,
});

export const getAllRoleData = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: user.allRoleData(),
  successCallback,
  mountedRef,
});

// this is used not for the logged in user, but for other users that are clicked on
// logged in user has this info in state
export const isRightEnabled = (internetUserId, rightName, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: user.rightEnabled(internetUserId, rightName),
  successCallback,
  mountedRef,
});

export const getUser = (internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: user.getUser(internetUserId),
  successCallback,
  mountedRef,
});

export const getUserListWithSearch = (searchTerm, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: user.getInternetUserList(searchTerm),
  successCallback,
  mountedRef,
});
